import { render } from "./MovieRecord.vue?vue&type=template&id=2f5a90f2"
import script from "./MovieRecord.vue?vue&type=script&lang=js"
export * from "./MovieRecord.vue?vue&type=script&lang=js"

import exportComponent from "/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__